import styled from "styled-components";

export const BookingDetailInfoStyled = styled.div`
  .booking_detail_header {
    margin-bottom: 41px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .booking_detail_title {
      color: ${({ theme }) => theme.COLORS.BLACK_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S17};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_SEMIBOLD};
    }
  }

  .booking_admin_note {
    margin-bottom: 35px;
    display: flex;
    column-gap: 30px;
    .booking_admin_note_title {
      flex-basis: 250px;
      color: ${({ theme }) => theme.COLORS.BLACK_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_REEGULAR};
    }
    .booking_admin_note_text {
      color: ${({ theme }) => theme.COLORS.BLACK_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_REGULAR};
    }
  }
  .booking {
    margin-bottom: 26px;
    .booking_header {
      margin-bottom: 18px;
      color: ${({ theme }) => theme.COLORS.BLACK_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S17};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_MEDIUM};
    }
    .booking_detail_row {
      margin-bottom: 4px;
      display: flex;
      .title {
        flex-basis: 250px;
        color: ${({ theme }) => theme.COLORS.BLACK_1};
        font-size: ${({ theme }) => theme.FONT.SIZE.S14};
        font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_REGULAR};
      }
      .text {
        color: ${({ theme }) => theme.COLORS.BLACK_1};
        font-size: ${({ theme }) => theme.FONT.SIZE.S14};
        font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_REGULAR};
        &.pre_wrap {
          flex: 1;
          white-space: pre-wrap;
          word-break: break-word;
        }
        /* ลิงก์ใน Special Request - URL ยาวให้ตัดบรรทัดได้ ไม่ดันเลย์เอาต์ */
        .text_link {
          color: ${({ theme }) => theme.COLORS.BLUE_3};
          text-decoration: underline;
          word-break: break-all;
        }
      }
    }
  }

  .theme_standard {
  }
`;

export const FormContainer = styled.div`
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.COLORS.GRAY_8};
  max-height: 80vh;
  max-width: 30%;
  width: 100%;
  overflow-y: auto;
  padding: 24px;
  background: ${({ theme }) => theme.COLORS.WHITE_1};
`;
